import { render } from "./notice.vue?vue&type=template&id=048fac24"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=048fac24&lang=css"
script.render = render

export default script